jQuery( function( $ ) {

	function updateCart() {
		if ($('[data-loading-icon]').length) {
			return false;
		}

		var qty        = $( this ).val(),
			currentVal = parseFloat( qty ),
			item_hash  = $( this ).attr( 'name' ).replace(/cart\[([\w]+)\]\[qty\]/g, "$1"),
			data       = {
				security: themevars.custom_update_total_price_nonce,
				quantity: currentVal,
				hash : item_hash
			},
			loading_icon = '<span class="loading-icon" data-loading-icon></span>';

		$( this ).after( loading_icon );

		$.post( wc_cart_fragments_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'custom_update_total_price' ), data, function( response ) {
			var data = $.parseJSON( response );
			$( '.shop_table_container #checkout-form' ).replaceWith( $( data.cart ).find( '#checkout-form' ) );
			$( '.woocommerce-cart .product-quantity' ).on( 'change', '.quantity', updateCart );
			window.addNumberFieldClickEvents();
		} ).done( function() {
			$( document.body ).trigger( 'updated_cart_totals' );
			$( '[data-loading-icon]' ).remove();
		} );
		return false;
	}

	//Custom update shopping cart
	$( '.woocommerce-cart .shop_table_container' ).on( 'change', '.product-quantity .quantity', updateCart );

	// remove loading icon after adding product to cart
	/*$('body').on('added_to_cart', function(e, fragments, cart_hash, $thisbutton) {
		var thisbutton_text = $thisbutton.data('button_text');
		$thisbutton.html(thisbutton_text);
		$( '[data-loading-icon]' ).remove();
	} );*/


	$('body').on('found_variation', function(e, variation) {
		let $form = $('.variations_form.cart');
		let $product = $form.closest( '.product' );

		$('.single_variation_wrap').removeClass('choose-other-event');

		$form.find( 'input[name="variation_id"], input.variation_id' )
			.val( variation.variation_id )
			.change();

		var $variation_el   = $form.find( '.variation-order-form-' + variation.variation_id );
		var $reservation_el = $( '#subscribe-availability-product.out-of-stock' );
		$( '.variation-price' ).css( 'display', 'none' );

		if ( $variation_el.length ) {
			$variation_el.css( 'display', 'block' );
			$( '.shipping.small .variation-shipping' ).css( 'display', 'none' );
			$( '.variation-price-' + variation.variation_id ).css( 'display', 'block' );
			$( '.shipping.small .variation-shipping-' + variation.variation_id ).css( 'display', 'inline' );

			$reservation_el.css( 'display', 'none' );
			$( '#subscribe-availability-product.out-of-stock-' + variation.variation_id ).css( 'display', 'block' );
		} else {
			// overwrite important on bootstrap grid
			$form.find( '.variation-order-form' ).map(function() {
				this.style.setProperty('display', 'none', 'important');
			});
			$reservation_el.css( 'display', 'block' );

			$('.single_variation_wrap').addClass('choose-other-event');
		}

		$form.find( "button[data-variation_id]" ).attr( "data-variation_id" , variation.variation_id );
		$form.find( "button[data-variation_id]" ).attr( "data-product_sku" , variation.sku );
		$form.find( "button[data-variation_id]" ).attr( "data-product_title" , variation.title );
		$form.find( "button[data-variation_id]" ).attr( "data-product_price" , variation.price );
		$form.find( "button[data-variation]" ).data( "variation" , variation );


		var $product_img = $product.find( 'div.images img:eq(0)' ),
			$product_link = $product.find( 'div.images a.zoom:eq(0)' ),
			o_src = $product_img.attr( 'data-o_src' ),
			o_title = $product_img.attr( 'data-o_title' ),
			o_alt = $product_img.attr( 'data-o_alt' ),
			o_href = $product_link.attr( 'data-o_href' ),
			variation_image = variation.image_src,
			variation_link  = variation.image_link,
			variation_caption = variation.image_caption,
			variation_title = variation.image_title;

		if ( o_src === undefined ) {
			o_src = ( ! $product_img.attr( 'src' ) ) ? '' : $product_img.attr( 'src' );
			$product_img.attr( 'data-o_src', o_src );
		}

		if ( o_href === undefined ) {
			o_href = ( ! $product_link.attr( 'href' ) ) ? '' : $product_link.attr( 'href' );
			$product_link.attr( 'data-o_href', o_href );
		}

		if ( o_title === undefined ) {
			o_title = ( ! $product_img.attr( 'title' ) ) ? '' : $product_img.attr( 'title' );
			$product_img.attr( 'data-o_title', o_title );
		}

		if ( o_alt === undefined ) {
			o_alt = ( ! $product_img.attr( 'alt' ) ) ? '' : $product_img.attr( 'alt' );
			$product_img.attr( 'data-o_alt', o_alt );
		}

		if ( variation_image && variation_image.length > 1 ) {
			$product_img
				.attr( 'src', variation_image )
				.attr( 'alt', variation_title )
				.attr( 'title', variation_title );
			$product_link
				.attr( 'href', variation_link )
				.attr( 'title', variation_caption );
		} else {
			$product_img
				.attr( 'src', o_src )
				.attr( 'alt', o_alt )
				.attr( 'title', o_title );
			$product_link
				.attr( 'href', o_href )
				.attr( 'title', o_title );
		}
	});

	function IsJsonString(str) {
	    try {
	        JSON.parse(str);
	    } catch (e) {
	        return false;
	    }
	    return true;
	}

	function bindAddToCartButton() {
		// Ajax add to cart
		// first unbind to make sure no double events are fired
		if ($('.add_to_cart_button.product_type_variable').length) {
			$('.add_to_cart_button').on('click',function(e) {

				if ( $( '[data-loading-icon]' ).length ) {
					return false;
				}

				// wc_add_to_cart_params is required to continue, ensure the object exists
				/*if ( typeof wc_add_to_cart_params === 'undefined' ) {
					return false;
				}*/

				// AJAX add to cart request
				var $thisbutton = $( this );

				if ( $thisbutton.is( '.product_type_variable' ) ) {

					if ( ! $thisbutton.data( 'product_id' ) || ! $thisbutton.data( 'variation_id' ) ) {
						return true;
					}

					$thisbutton.removeClass( 'added' );
					$thisbutton.addClass( 'loading' );

					var data = {
						action 			: 'woocommerce_add_variation_to_cart',
						product_id 		: $thisbutton.data( 'product_id' ),
						quantity 		: $thisbutton.data( 'quantity' ),
						variation_id 	: $thisbutton.data( 'variation_id' ),
						variation 		: $thisbutton.data( 'variation' )
					};

					// Trigger event
					$( document.body ).trigger( 'adding_to_cart', [ $thisbutton, data ] );

					// Ajax action
					$.post( wc_add_to_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'woocommerce_add_variation_to_cart' ), data, function( response ) {

						if ( ! response ) {
							return;
						}

						var this_page = window.location.toString();
						this_page = this_page.replace( 'add-to-cart', 'added-to-cart' );

						if ( response.error && response.product_url ) {
							window.location = response.product_url;
							return;
						}

						// Redirect to cart option
						if ( wc_add_to_cart_params.cart_redirect_after_add === 'yes' ) {
							window.location = wc_add_to_cart_params.cart_url;
							return;
						}
						else {
							$thisbutton.removeClass( 'loading' );

							var fragments = response.fragments;
							var cart_hash = response.cart_hash;

							// Block fragments class
							if ( fragments ) {
								$.each( fragments, function( key ) {
									$( key ).addClass( 'updating' );
								} );
							}

							// Block widgets and fragments
							$( '.shop_table.cart, .updating, .cart_totals' ).fadeTo( '400', '0.6' ).block({
								message: null,
								overlayCSS: {
									opacity: 0.6
								}
							} );

							// Changes button classes
							$thisbutton.addClass( 'added' );

							// View cart text
							/*if ( ! wc_add_to_cart_params.is_cart && $thisbutton.parent().find( '.added_to_cart' ).size() === 0 ) {
								$thisbutton.after( ' <a href="' + wc_add_to_cart_params.cart_url + '" class="added_to_cart wc-forward" title="' +
									wc_add_to_cart_params.i18n_view_cart + '">' + wc_add_to_cart_params.i18n_view_cart + '</a>' );
							}*/

							// Replace fragments
							if ( fragments ) {
								$.each( fragments, function( key, value ) {
									$( key ).replaceWith( value );
								} );
							}

							// Unblock
							$( '.widget_shopping_cart, .updating' ).stop( true ).css( 'opacity', '1' ).unblock();

							// Cart page elements
							$( '.shop_table.cart' ).load( this_page + ' .shop_table.cart:eq(0) > *', function() {

								$( '.shop_table.cart' ).stop( true ).css( 'opacity', '1' ).unblock();
								$( document.body ).trigger( 'cart_page_refreshed' );
								window.addNumberFieldClickEvents();

								$( '.woocommerce-cart .product-quantity' ).on( 'change', '.quantity, select', updateCart );
							} );

							$( '.cart_totals' ).load( this_page + ' .cart_totals:eq(0) > *', function() {
								$( '.cart_totals' ).stop( true ).css( 'opacity', '1' ).unblock();
							} );

							// Trigger event so themes can refresh other areas
							$( document.body ).trigger( 'added_to_cart', [ fragments, cart_hash, $thisbutton ] );
						}
					} );
					return false;
				}
				return false;
			} );
		}
	}



	bindAddToCartButton(); // made a function of it to accomodate async buttons (like vue)

	// Vue trigger only!
	$(document.body).on('bind_add_to_cart_button', function() {
		// jquery does not read data attributes from the page. Instead it reads them from cache.
		// Thus, if you do not update the data attribute with the jquery function, it does not update
		// Seeing this is a vue trigger only, we update the data attribute for jquery here
		var $thisbutton = $('.add_to_cart_button');
		$thisbutton.data('product_id', $thisbutton.attr('data-product_id'));
		$thisbutton.data('quantity', $thisbutton.attr('data-quantity'));
		$thisbutton.data('variation_id', $thisbutton.attr('data-variation_id'));
		$thisbutton.data('product_title', $thisbutton.attr('data-product_title'));
		$thisbutton.data('product_price', $thisbutton.attr('data-product_price'));
		$thisbutton.data('product_category', $thisbutton.attr('data-product_category'));
		$thisbutton.data('variation', (IsJsonString($thisbutton.attr('data-variation'))) ? JSON.parse($thisbutton.attr('data-variation')) : $thisbutton.attr('data-variation'));
		bindAddToCartButton();
		// window.addNumberFieldClickEvents();
		// updateCart();

	});
} );
